import { LOCALES } from "../locales";

export default {
  [LOCALES.CHINESE]: {
    //Nav
    home: "首页",
    referral: "推荐",
    api: "API",
    faqs: "常见问题",
    language: "语言",
    profile: "个人主页",
    changePassword: "修改密码",
    signup: "注册账户",
    login: "登录账户",
    logout: "登出账户",

    //Banner 0
    ETIQAAFFILIATES: "ETIQA APIs",
    "banner-subtitle": "适用于合作伙伴和开发人员",
    "banner-subtitle2": "将保险解决方案轻松集成到任何应用程序或网站中",

    //content 5
    "content5-title": "APIs",
    "content5-sub-title":
      "欢迎使用Etiqa API门户。 Etiqa API门户提供API服务，从而简化了通过您的网站或移动应用程序销售和提供我们产品的过程。",

    //Feature 8
    "feature8-title": "三个简单的步骤",
    "feature8-item-title1": "1) 注册 / 登录 ",
    "feature8-item-sub-title1": "注册并登录以浏览我们API的完整列表。",
    "feature8-item-title2": "2) 选择API",
    "feature8-item-sub-title2": "选择具有不同定制级别的集成选项。",
    "feature8-item-title3": "3) 整合服务",
    "feature8-item-sub-title3": "将产品与您的网站或应用程序以及GO LIVE集成。",

    //Banner 5
    "banner5-title": "需要帮助吗？",
    "banner5-sub-title": "常见问题",
    "banner5-item1": "1) 关于Etiqa API门户",
    "banner5-item2": "2) 如何访问API？",
    "banner5-item3": "3) 什么是API？",
    "banner5-item4": "4) 什么是JWT WEB令牌？",
    "banner5-button": "了解更多",

    //REFERRAL
    "Referral-catalog": "推荐目录",
    "Referral-content": "立即注册以获取您唯一的推荐链接并开始共享！",
    "Referral-sub-title": "我们的推荐计划的工作方式",
    "Referral-item-title1": "注册并推荐",
    "Referral-item-sub-title1": "注册并检索“推荐目录”下的唯一引用链接",
    "Referral-item-title2": "轻松共享",
    "Referral-item-sub-title2": "轻松地在您喜欢的社交媒体上分享",
    "Referral-item-title3": "获得奖励",
    "Referral-item-sub-title3": "每成功购买推荐人，即可获得奖励",
    half_term1: "*请参阅我们的",
    half_term2: "引荐条款和条件",
    half_term3: "从而了解更多详情",
    "Referral-nav1": "全部",
    "Referral-nav2": "交通",
    "Referral-nav3": "PA",
    "Referral-nav4": "火",
    "Referral-nav5": "BOND",
    "Referral-nav6": "生命",
    "Referral-nav7": "其他",
    "Referral-question-title": "仍然对（Etiqa）推荐有疑问吗？",
    "Referral-question1": "我必须是现有的Etiqa客户才能开始推荐吗？",
    "Referral-answer1":
      "不会立即。您甚至可以在成为Etiqa客户之前就开始推荐。您可以在购买Etiqa后再兑换推荐奖励。",
    "Referral-question2": "我可以推荐多少人？",
    "Referral-answer2": "没有限制。",
    "Referral-question3": "需要多长时间才能获得付款？",
    "Referral-answer3":
      "您的推荐奖励将在保单开始60天后记入您的Etiqa电子钱包。如果您尚未购买保单，那么您将在保单开始60天后收到您的推荐奖励。",
    "Referral-question4": "我将如何获得报酬？",
    "Referral-answer4":
      "推荐奖励将计入您的Etiqa电子钱包，您可以选择将其兑现或用于以后的Etiqa购买。",
    "Referral-question5": "我如何兑现推荐奖励？",
    "Referral-answer5":
      "您可以登录TiqConnect设置直接信用银行转帐，或使用PayNow将您的电子钱包中的信用额兑现到您的新加坡银行帐户。",

    //API

    //FAQs
    "faq-title": "常见问题解答",
    "sub-faq-title": "需要帮助吗？",
    "panel-header1": "关于Etiqa API门户",
    "panel-content1":
      "有兴趣向您的用户提供我们的保险解决方案吗？合作伙伴可以通过利用我们的API，小部件或营销资产来做到这一点。",
    "panel-header2": "什么是API？",
    "panel-content2":
      "从根本上讲，API（应用程序编程接口）是应用程序的接口，允许其他应用程序与其通信。在Etiqa API Portal上访问实时数据和服务。要查看可用功能，请执行以下操作：查看我们的",
    "panel-header3": "如何访问API？",
    "panel-content3":
      "注册并创建免费的开发者帐户，即可立即访问Etiqa的沙盒环境。成功登录后，通过我们的门户轻松获取入门文档。",
    "panel-header4": "什么是JWT WEB令牌？",
    "panel-content4":
      "JSON Web令牌（JWT，RFC 7519）是一种对随后签名的JSON文档中的声明进行编码的方法。JWT可以用作OAuth 2.0承载令牌，以将访问令牌的所有相关部分编码到访问中令牌本身，而不必将其存储在数据库中。",
  },
};
